import { render, staticRenderFns } from "./SiteWideLinks.vue?vue&type=template&id=59dbc8b7&"
import script from "./SiteWideLinks.vue?vue&type=script&lang=js&"
export * from "./SiteWideLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports